import React, { useState } from 'react'
import _uniqueId from 'lodash/uniqueId'
import styled from 'styled-components'
import validators from 'src/validators'
import Form from 'src/components/Form'
import * as Yup from 'yup'
import apiService from 'src/services/apiService'

import Textarea from 'src/components/Fields/Textarea'
import Recaptcha from 'src/components/Fields/Recaptcha'
import UserSvg from 'src/assets/User.svg'
import EmailSvg from 'src/assets/Email.svg'
import PointerSvg from 'src/assets/Pointer.svg'

import { useInternationalisation } from 'src/context'
import { getCentreConfig } from 'src/config'
import _get from 'lodash/get'
import env, { isCordova, isBrowser } from 'src/env'
import Page, { getPageData } from 'src/components/Page'
import Button from 'src/components/Button'

let fieldSchema = [
  {
    name: 'firstname',
    label: 'INPUT_FIRST_NAME',
    autoComplete: 'firstname',
    iconSvg: UserSvg,
    width: { sm: 1, md: 0.5 }
  },
  {
    name: 'surname',
    label: 'INPUT_LAST_NAME',
    autoComplete: 'surname',
    iconSvg: UserSvg,
    width: { sm: 1, md: 0.5 }
  },
  {
    name: 'email',
    label: 'INPUT_EMAIL',
    autoComplete: 'email',
    type: 'email',
    iconSvg: EmailSvg
  },
  {
    name: 'message',
    label: 'INPUT_MESSAGE',
    autoComplete: 'message',
    iconSvg: PointerSvg,
    component: Textarea,
    rows: 5
  }
]

let validationSchemaObject = {
  firstname: validators.requiredString(),
  surname: validators.requiredString(),
  message: validators.requiredString(),
  email: validators.email()
}

if (!isCordova) {
  fieldSchema.push({
    name: 'recaptcha',
    component: Recaptcha
  })
  validationSchemaObject.recaptcha = validators.requiredString()
}

const FormWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;
`

const CritizrButton = styled(Button)`
  border: 1px solid #000;
  background-color: #000;
  font-family: "Poppins",sans-serif;
  font-weight: 400;
  letter-spacing: normal;
  color: #fff;
  border-radius: 0;
  box-shadow: none;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 32px;
  height: 34px;
  
  div {
    font-size: 14px;
    font-family: "Poppins",sans-serif;
    font-weight: 400;
    letter-spacing: normal;
    line-height: 32px;
    padding: 0 4px;
  }
`

const LogoImage = styled.div`
  background-image: url('data:image/png;base64,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');
  background-position: center center;
  background-repeat: no-repeat;
  flex: 1 1 auto;
  background-size: contain;
  width: 35px;
  height: 35px;
`

const Contact = (props) => {
  const [sentKey, setSentKey] = useState(null)
  const onSubmit = React.useCallback((values) => {
    const { firstname, surname, email, message } = values
    const args = {
      name: `${firstname} ${surname}`,
      email,
      message
    }
    return apiService.postContactForm(args).then(() => setSentKey(_uniqueId()))
  }, [])

  const { critizrApiKey } = env
  const { critizrCentreKey } = getCentreConfig() || {}
  const { isFrenchCentre, translate } = useInternationalisation()
  const validationSchema = Yup.object(validationSchemaObject)

  const formProps = {
    fieldSchema,
    validationSchema,
    onSubmit: onSubmit,
    buttonLabel: 'BUTTON_LABEL_SEND',
    successMessage: 'Thanks for your message!',
    resetOnSuccess: true
  }

  const handleClick = () => window.CritizrSDK.open("modal:send_feedback", critizrCentreKey, {
    "mode": "feedbackonly",
    "lang": isFrenchCentre ? 'fr' : 'en'
  })

  const renderFeedbackForm = () => {
    if (isBrowser) {
      if (critizrCentreKey && critizrApiKey) {
        return (
          <CritizrButton
            className="foo"
            onClick={handleClick}>
            <LogoImage />{translate('PAGE_CONTACT_US')}
          </CritizrButton>
   
        )
      } else {
        return (
          <FormWrapper>
            <Form {...formProps} />
          </FormWrapper>
        )
      }
    }
    return null
  }

  return (
    <Page box inner>
      {renderFeedbackForm()}
    </Page>
  )
}

Contact.identifier = 'CONTACT'

Contact.getData = (props) => {
  return getPageData(props)
}

export default Contact
